import React, { useEffect, useState } from "react";
import AutomaticTestingToolHeader from "../components/automatic-testing-tool-header";
import InputComponent from "../components/input-component/input-component";
import { CircularProgress } from "@material-ui/core";

export default function AI() {
  const title = 'AI Full review 🪄';
  const description = "Executing hundreds of static and dynamic tests on smart contracts using advanced AI technology to detect potential vulnerabilities, anomalies, functionality flaws, efficiency issues, code quality concerns, access control weaknesses, and upgradability challenges with high precision."

  var [isLoading, setLoading] = useState(false)
  var [compilerVersion, setCompilerVersion] = useState('')
  var [mainContract, setMainContract] = useState('')
  var [compilerSettings, setCompilerSettings] = useState('')
  var [mainFile, setMainFile] = useState('')
  var [selectedFilePath, setSelectedFilePath] = useState('')
  var [files, setFiles] = useState([])
  const [importPopoverAnchorEl, setImportPopoverAnchorEl] = useState(null)
  const [done, set_done] = useState([])
  var resources = [
    {
      name: "Functions",
      tasksPerItem: [
        "The source code shows that the function behave as it required.",
        "The function tested in normal condition and it works as expected.",
        "The function tested by using extreme values for each parameter and it works as expected.",
        "The function tested that it is failing when executed without permission.",
        "The function tested that it is failing when it should fail (Such as not sufficient balance).",
        "Everything that this function does can be reverted.",
        "The function name clearly describe what it should do.",
        "The parameter types are following the requirements.",
        "The function return type is following the requirements.",
        "All input parameters are in-use, or no need for input parameters.",
        "The function should modify all of those storage variables.",
        "The source code shows that the function is using the storage according to the requirements.",
        "The function tested with different storage values and it works properly.",
        "The function tested while those storage holds an extreme values, and it works or revert as expected.",
        "The function should emitting all of those events.",
        "The events are emitted every place they needed to be emitted.",
        "The events are emitted using the correct parameters in the correct order.",
      ],
      items: [
        {
          name: 'approve',
        },
        {
          name: 'transfer',
        },
        {
          name: 'transferFrom',
        },
        {
          name: 'pause',
        },
      ]
    },
    {
      name: "Modifiers",
      tasksPerItem: [
        "The source code shows that the modifier behave as it required.",
        "The modifier tested in normal condition and it works as expected.",
        "The modifier tested by using extreme values for each parameter and it works as expected.",
        "The modifier tested that it is failing when executed without permission.",
        "The modifier tested that it is failing when it should fail (Such as not sufficient balance).",
        "Everything that this modifier does can be reverted.",
        "The modifier name clearly describe what it should do.",
        "The parameter types are following the requirements.",
        "The modifier return type is following the requirements.",
        "All input parameters are in-use, or no need for input parameters.",
        "The modifier should modify all of those storage variables.",
        "The source code shows that the modifier is using the storage according to the requirements.",
        "The funciton tested with different storage values and it works properly.",
        "The modifier tested while those storage holds an extreme values, and it works or revert as expected.",
        "The modifer should emitting all of those events.",        
      ],
      items: [
        {
          name: 'onlyOwner',
        },
        {
          name: 'onlyMinter',
        },
        {
          name: 'onlyPauser',
        },
        {
          name: 'whileNotPaused',
        },
      ]
    },
    {
      name: "Storage",
      tasksPerItem: [
        "The functions that read this storage are work correctly",
        "There is no missing functions that should be depeneded on that storage",
        "Only users with permission are able to modify this storage",
        "The storage is protected from underflow/overflow"
      ],
      items: [
        {
          name:'balances'
        },
        {
          name:'owners'
        },
        {
          name:'pausers'
        },
        {
          name:'allowances'
        }
      ]
    },
    {
      name: "Events",
      tasksPerItem: [
        "The events are emitted every place they needed to be emitted.",
        "The events are emitted using the correct parameters in the correct order.",
      ],
      items: [
        {
          name:"Minted",
        },
        {
          name:'Transfer',
        },
        {
          name:'Approve',
        },
        {
          name:'Pause',
        },
        {
          name:'Unpause',
        }
      ]
    },
  ]
  function setABI() {
  }
  function submitCode() {
    set_done([])
    setLoading(true)
    set_showScanResult(true)
    setLoading(false)
  }
  var [showScanResult,set_showScanResult]=useState(false)
  var [selectedResourceType, set_selectedResourceType] = useState(resources[0].name)
  var selectedResource=resources.find(x => x.name == selectedResourceType)
  var i=0
  useEffect(()=>{
    let int=[]
    if(showScanResult) {
      for(let i=0;i<100;i++) {
        var x=setTimeout(()=>{
          set_done(_=>[
            ..._,
            i
          ])
          console.log(i)
        },Math.random()*30000)
        int.push(x)
      }
    }
    return ()=>int.forEach(i=>clearInterval(i))
  },[showScanResult])
  return (
    <div
      css={
        `
      padding: 35px;
      background: #F6F6FA;
      min-height: 100vh;
      `
      }
    >
      <AutomaticTestingToolHeader title={title} description={description}></AutomaticTestingToolHeader>

      <hr css={`
            margin-top:15px;
            border: 1px solid #EAEAF2;
            `}
      />
      <div
        css={`
            margin-top:25px;
            margin-bottom:100px;
          `}
      >
        <InputComponent
          skipSampleProjects
          onX={submitCode}
          ctaText="Scan"
          showValidationBtn={false}
          files={files}
          setFiles={setFiles}
          isLoading={isLoading}
          compilerVersion={compilerVersion}
          setCompilerVersion={setCompilerVersion}
          mainContract={mainContract}
          compilerSettings={compilerSettings}
          setCompilerSettings={setCompilerSettings}
          setMainFile={setMainFile}
          mainFile={mainFile}
          setMainContract={setMainContract}
          selectedFilePath={selectedFilePath}
          setSelectedFilePath={setSelectedFilePath}
          importPopoverAnchorEl={importPopoverAnchorEl}
          setImportPopoverAnchorEl={setImportPopoverAnchorEl}
          setABI={setABI}
        />
      </div>
      {showScanResult && 
      <div>{resources.map(resource => {
        var selected = resource.name == selectedResourceType
        return <div
          onClick={() => set_selectedResourceType(resource.name)}
          css={`
          display:inline-block;
          padding:10px 20px;
          display:inline-flex;
          cursor:pointer;
          font-size:16px;
          border:1px solid ${selected ? 'black' : 'transparent'};
          background:${selected ? 'darkgreen' : 'white'};
          color:${selected ? 'white' : 'black'};
      `}>
          <div>
            <CircularProgress size={16} />
            &nbsp;
          </div>
          <div>
            {resource.name}
          </div>
        </div>
      })}
      <div css={`border:1px solid gray;padding:10px;font-size:14px;`}>
        {selectedResource?.items?.map(oneResourceItem => {
          return <div>
            <div css={`font-weight:bold;background:#dddd;color:black;padding:10px 5px;`}>
              {oneResourceItem.name}
            </div>
            {selectedResource.tasksPerItem?.map(x => {
              i++
              var isDone=done.includes(i)
              var isFail=i % 5==0
              return <div css={`padding:5px 5px; cursor:pointer; :hover {font-weight:bold;}`}>
                {isDone && !isFail && <span css={`color:green;`}>✔︎</span>}
                {isDone && isFail && <span css={`color:red;`}>❌</span>}
                {!isDone && <CircularProgress size={14}/>}
                &nbsp;{x}
              </div>
            })}
          </div>
        })}
      </div>
      </div>}
      <br />
      <br />
      <br />
    </div>
  )
}